import { SkeletonLoader, StyledComponent } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SectionTitle } from '~/components/section-title/SectionTitle';

import { KeyValueElement } from './components/KeyValueElement';
import { useKeyValues } from './hooks/use-key-values/useKeyValues';
import * as S from './OverviewKeyValues.styles';

export interface OverviewKeyValuesProps {
  entityTag: string;
  isDefaultVariant?: boolean;
}

export const OverviewKeyValues: StyledComponent<
  OverviewKeyValuesProps,
  typeof S
> = ({ entityTag, isDefaultVariant = true }: OverviewKeyValuesProps) => {
  const { t } = useTranslation('widget');

  const { data, isError, isFetching, error } = useKeyValues(entityTag);

  if (isFetching) {
    return (
      <SkeletonLoader
        areas={S.keyValueSkeletonLoaderAreas}
        data-testid="loading-state"
      />
    );
  }

  if (isError) {
    throw error;
  }

  if (!data?.length) {
    return null;
  }

  const filteredData = data.filter(d => d.value_fmt !== undefined);
  return (
    <S.OverviewKeyValuesRoot data-testid="overview-key-values">
      {isDefaultVariant && (
        <SectionTitle title={t('widget:assetOverview.keyValuesTitle')} />
      )}
      <S.KeyValuesList>
        {filteredData.map(keyValue => (
          <KeyValueElement
            key={keyValue.key}
            keyValue={keyValue}
            isDefaultVariant={isDefaultVariant}
          />
        ))}
      </S.KeyValuesList>
    </S.OverviewKeyValuesRoot>
  );
};

OverviewKeyValues.Styled = S;
